var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-content",class:[_vm.type === 'admin' ? 'admin' : 'ecp']},[_c('p',{staticStyle:{"margin-bottom":"30px"}},[_vm._v("Copyright © 2021 专属云")])])])}
var staticRenderFns = []

export { render, staticRenderFns }